<div class="card main-card mb-0">
  <ng-content></ng-content>
</div>
